import {
  Stethoscope,
  FileText,
  ClipboardList,
  FileSearch,
  Building2,
  Database,
  UserPlus,
   LucideIcon,
} from "lucide-react";

export const notificationTypeConfig: Record<
  NotificationType,
  { icon: LucideIcon; bg: string; color: string }
> = {
  admission: { icon: Stethoscope, bg: "bg-teal-soft", color: "text-teal" },
  invoice: { icon: FileText, bg: "bg-primary-soft", color: "text-primary" },
  authorization: { icon: ClipboardList, bg: "bg-yellow-soft", color: "text-yellow" },
  convention: { icon: FileSearch, bg: "bg-purple-soft", color: "text-purple" },
  provider: { icon: Building2, bg: "bg-pink-soft", color: "text-pink" },
  employee: { icon: UserPlus, bg: "bg-green/10", color: "text-green" },
  system: { icon: Database, bg: "bg-card-muted", color: "text-muted-foreground" },
};
